import { CalculationItem } from './calculations';
import { SHARED_GLOSSARY } from './shared-glossary';

export const SHARED_CALCULATIONS = {
  incrementalReturnOnAdSpend: {
    label: 'Incremental Return on Ad Spend (IROAS)',
    calculationType: 'simple',
    calculation:
      'IROAS = Incremental Sales / (Ad Spend * Days Elapsed / Campaign Duration)',
    definition: SHARED_GLOSSARY.incrementalReturnOnAdSpend.definition,
  },
  returnOnAdSpend: {
    label: 'Return on Ad Spend (ROAS)',
    calculationType: 'simple',
    calculation:
      'ROAS = Total Sales / (Ad Spend * Days Elapsed / Campaign Duration)',
    definition: SHARED_GLOSSARY.returnOnAdSpend.definition,
  },
} as const satisfies Record<string, CalculationItem>;
